import { useInvoice, useMelioIntl } from '@melio/ar-domain';
import { Modal } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';

export type SendInvoiceModalActivityProps = {
  onError?: ErrorFunction;
  onClose: VoidFunction;
  onDone?: VoidFunction;
  invoiceId?: string;
};

export const SendInvoiceModalActivity = forwardRef<SendInvoiceModalActivityProps>(
  ({ invoiceId, onClose, onError, onDone = onClose, ...props }, ref) => {
    const { share: sendInvoice, isMutating: isSendingInvoice } = useInvoice({ id: invoiceId, enabled: false });
    const { formatMessage } = useMelioIntl();
    const onSendInvoice = () =>
      void sendInvoice({ sentFrom: 'partner', type: 'createInvoice' }).then(onDone).catch(onError);

    return (
      <Modal
        data-testid={`send-invoice-modal-activity-${invoiceId ?? ''}`}
        data-component={SendInvoiceModalActivity.displayName}
        header={formatMessage('ar.invoiceLifecycle.activities.sendInvoice.header.text')}
        description={formatMessage('ar.invoiceLifecycle.activities.sendInvoice.description.text')}
        shouldHideCloseButton
        isOpen={!!invoiceId}
        onClose={onClose}
        secondaryButton={{ isDisabled: isSendingInvoice, label: 'Cancel', onClick: onClose, variant: 'secondary' }}
        primaryButton={{
          isLoading: isSendingInvoice,
          label: formatMessage('ar.invoiceLifecycle.activities.sendInvoice.buttons.send.label'),
          variant: 'primary',
          onClick: onSendInvoice,
        }}
        {...props}
        ref={ref}
      />
    );
  }
);
SendInvoiceModalActivity.displayName = 'SendInvoiceModalActivity';
